export const shareBetHost: string = 'm.letsbetmd.com';
